import createModel, { prop } from 'models/lib/create_model';

export const OfferedPrompt = createModel({
  modelName: 'OfferedPrompt',

  properties: {
    id: prop(String).isRequired,
    text: prop(String).isRequired,
  },
});

export const ButtonPromptSelected = createModel({
  modelName: 'ButtonPromptSelected',

  properties: {
    offeredPrompts: prop([OfferedPrompt]).isRequired,
    promptsSource: prop(String).isRequired,
    selectedPromptId: prop(String).isRequired,
    launcherId: prop(String).isRequired,
    pageUrl: prop(String).isRequired,
  },
});
